import {
  CATEGORY,
  CLASSIFICATION,
  COMMON_THEMATIC,
  EXPERTISE,
  FINANCIAL_PUBLICATION,
  PUBLICATION,
  REGION,
  THEMATIC,
} from './filters';

export enum DocumentType {
  ARTICLE = 'article',
  BRANCH_ACTIVITIES = 'branch_activities',
  COLD_ARTICLE = 'cold_article',
  CONTACT_PAGE = 'contact_page',
  CONTACT = 'contact',
  FINANCIAL_DEBT = 'financial_debt',
  FINANCIAL_KEY_FIGURES = 'financial_key_figures',
  FINANCIAL_PRESS_RELEASE = 'financial_press_release',
  FINANCIAL_PUBLICATION = 'financial_publication',
  FINANCIAL_RATING = 'financial_rating',
  FOOTER = 'footer',
  GOUVERNANCE = 'gouvernance',
  HEADER = 'header',
  HOME = 'home',
  HUB_ACTUS = 'hub_actus',
  HUB_NEWSROOM = 'hub_newsroom',
  HOT_ARTICLE = 'hot_article',
  LA_POSTE_EN_4 = 'la_poste_en_4',
  MEDIA_PRESS = 'media_presse',
  MEDIA_PRESS_RELEASE = 'media_presse_release',
  NEWSROOM = 'newsroom',
  POSTMEN = 'postmen',
  PRESS_RELEASE = 'press_release',
  PUBLIC_SERVICE_MISSIONS = 'public_service_missions',
  SEARCH_PAGE = 'search_page',
}

export enum TranslationType {
  TRANSLATION = 'translation',
}

export type CustomType = DocumentType | TranslationType;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomType = {
  ...DocumentType,
  ...TranslationType,
};

export const singleDocumentTypes = [
  DocumentType.BRANCH_ACTIVITIES,
  DocumentType.CONTACT_PAGE,
  DocumentType.FINANCIAL_DEBT,
  DocumentType.FINANCIAL_KEY_FIGURES,
  DocumentType.FINANCIAL_PRESS_RELEASE,
  DocumentType.FINANCIAL_PUBLICATION,
  DocumentType.FINANCIAL_RATING,
  DocumentType.FOOTER,
  DocumentType.GOUVERNANCE,
  DocumentType.HEADER,
  DocumentType.HUB_ACTUS,
  DocumentType.HUB_NEWSROOM,
  DocumentType.NEWSROOM,
  DocumentType.POSTMEN,
  DocumentType.PUBLIC_SERVICE_MISSIONS,
  DocumentType.SEARCH_PAGE,
];

export type DocumentLink = Document & {
  linkType: string;
};

type DeprecatedWarning = {
  field: string;
  oldValue: string | boolean | number;
};

export type Document = {
  id: string;
  uid: string;
  type: DocumentType;
  lang: string;
  alternateLanguages: DocumentLink[];
  createdAt: number;
  updatedAt: number;
  deprecated?: DeprecatedWarning[];
};

export type Translation = {
  id: string;
  type: TranslationType;
  lang: string;
  body: Record<string, string>;
};

export type Filters = {
  category?: CATEGORY;
  classification?: CLASSIFICATION;
  commonThematic?: COMMON_THEMATIC;
  expertise?: EXPERTISE;
  financialPublication?: FINANCIAL_PUBLICATION;
  mediaThematic?: THEMATIC;
  mediaType?: string;
  publication?: PUBLICATION;
  region?: REGION;
  thematic?: THEMATIC;
};
